import { createMuiTheme, makeStyles } from '@material-ui/core';
import {colores} from 'AppStyle';

export const customStyle = makeStyles({
    slide:{
        height: '100%'
    },
    iconoAyuda:{
        color: colores.principales.principal,
        height: '20px',
        width: '20px'
    }
})

export const style = createMuiTheme({
    overrides: {
        MuiPopover: {
            root: {
                left: '8px',
                right: '0px',
                top: '250px',
                marginTop: '6%'
            },
        },
        MuiPaper:{
            root:{
                height: 'fit-content',
                maxHeight: '200px',
                width: '100%',
                left: '8px',
                right: '0px',
                top: '250px',
            },
            elevation8:{
                boxShadow: `0px 5px 5px -3px ${colores.escalaGrises.diez}`
            }
        }, MuiIconLabel: {
            display: 'flex'
        }
    }
});